/**
 * タイムピッカー - コンポーネント
* @see src/plugins/wickedpicker.js
 * @see ABUI_doc__Component_Timepicker.html
 */
{


  // アイコン付与
  if ($('.input-timepicker').length) {
    $('.input-timepicker').each(function(index, element){
      $(element).wrap('<div class="input-with-icon">');
      $(element).after('<span class="input-icon icon-abui-time"></span>');
      var inputWithIcon = $(element).parent('.input-with-icon');
      if (inputWithIcon.parent('.input-group').length) {
        var inputGroupAddonWidth = inputWithIcon.next('.input-group-addon').innerWidth();
        $(element).next('.input-icon').css('right', parseInt(inputGroupAddonWidth)+1);
      }
    })
  }
}